module.exports = __webpack_public_path__ + "static/media/editPwd.da3b60b3.svg";